export default {
    beforeCreate() {
        const options = this.$options;
        const repository = options.$repository || (options.parent ? options.parent.$repository : null);
        if (!repository)
            return;

        this.$repository = repository;
        Object.keys(repository).forEach((key, index) => {
            this[`$${key}`] = repository[key];
        })
    },
}



// WEBPACK FOOTER //
// ./src/seedwork/mixins/repositoryProvider.js